import { Route } from "@angular/router";
import { TogglTestComponent } from "./toggl-test/toggl-test.component";
import { TogglUserMatchComponent } from "./toggl-user-match/toggl-user-match.component";
import { TogglJobMatchComponent } from "./toggl-job-match/toggl-job-match.component";
import { TogglTimeEntriesComponent } from "./toggl-time-entries/toggl-time-entries.component";
import { TogglScheduleComponent } from "./toggl-schedule/toggl-schedule.component";

export const togglRoutes: Route[] = [
    {
        path: 'toggl',
        children: [
            { path: 'test', component: TogglTestComponent },
            { path: 'matchusers', component: TogglUserMatchComponent },
            { path: 'matchjobs', component: TogglJobMatchComponent },
            { path: 'timeentries', component: TogglTimeEntriesComponent},
            { path: 'schedule', component: TogglScheduleComponent},
            { path: 'timer', redirectTo: '/timesheets/timer', pathMatch: 'full' },
            { path: 'reports', redirectTo: '/timesheets/reports', pathMatch: 'full' },
        ]
    }
];